import React, { useEffect, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import classes from './Tabs.module.scss';
import Actions from './components/Actions/Actions';
import Attendance from './components/Attendance/Attendance';
import CanteenMenu from './components/CanteenMenu/CanteenMenu';
//import OtherSnacks from './components/OtherSnacks/Othersnacks';
import { fetchAttendance } from '../../../../API/API';
import toast from 'react-hot-toast';

const Tabs = () => {
  const [openActions, setOpenActions] = useState(true);
  const [openAttendance, setOpenAttendance] = useState(false);
  const [openCanteen, setOpenCanteen] = useState(false);
  const [openOthersnacks, setOpenOthersnacks] = useState(false);
  const [isModules, setIsModules] = useState([]);
  const [viewAtt, setViewAtt] = useState([]);

  const modules = JSON.parse(localStorage.getItem('modules'));

  useEffect(() => {
    if (modules !== null) {
      setIsModules(modules)
    }
  }, [])


  //For Opening Actions Tab
  const openActionsTab = () => {
    setOpenActions(true);
    setOpenAttendance(false);
    setOpenCanteen(false);
    setOpenOthersnacks(false);
  }

  //For Opening Attendance Tab
  const openAttendanceTab = async () => {
    const userID = localStorage.getItem('userID')
    const data = JSON.parse(localStorage.getItem('data'));
    if (userID !== null) {
      const date = new Date();
      const fifteenDaysAgo = new Date();
      fifteenDaysAgo.setDate(fifteenDaysAgo.getDate() - 15);

      const currentDate = date.toISOString().substring(0, 10);
      const newDate = fifteenDaysAgo.toISOString().substring(0, 10);

      try {
        const response = await fetchAttendance(userID, data.empid, data.token, newDate, currentDate);
        setViewAtt(response.data);
      }
      catch (error) {
        toast(error.message, {
          icon: '❗',
          duration: 4500
        });
      }
    } else {
      toast('Problem in Opening', {
        icon: '❗',
        duration: 4500
      });
    }
    setOpenOthersnacks(false);
    setOpenActions(false);
    setOpenCanteen(false);
    setOpenAttendance(true);
  }

  const openCanteenTab = () => {
    setOpenActions(false);
    setOpenAttendance(false);
    setOpenOthersnacks(false);
    setOpenCanteen(true);
  }

  const openOthersnacksTab = () => {
    setOpenActions(false);
    setOpenAttendance(false);
    setOpenCanteen(false);
    setOpenOthersnacks(true);
  }

  return (
    <div className={classes.Tabs}>
      <div className={classes.TabsOptions}>
        <span className={openActions ? classes.Active : ""} onClick={openActionsTab}>Actions</span>
        {isModules.includes("ATTENDANCE") && <span className={openAttendance ? classes.Active : ""} onClick={openAttendanceTab}>Attendance</span>}
        {isModules.includes("CANTEEN") && <span className={openCanteen ? classes.Active : ""} onClick={openCanteenTab}>Cafeteria</span>}
        {/* {isModules.includes("CANTEEN") && <span className={openOthersnacks ? classes.Active : ""} onClick={openOthersnacksTab}>Other Snacks</span>} */}
      </div>

      {openActions && <Actions modules={isModules} />}
      {openAttendance && <Attendance viewAtt={viewAtt} />}
      {openCanteen && <CanteenMenu />}
      {/* {openOthersnacks && <OtherSnacks/>} */}
    </div>
  )
}

export default Tabs;